'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_RadioButtonProps = {
  /**
   * name of the input
   */
  name: require('prop-types').string,

  /**
   * The value of the radio button
   */
  value: require('prop-types').string,

  /**
   * If `true`, the radio button is selected
   */
  checked: require('prop-types').bool,

  /**
   * If `true`, the radio button will be disabled.
   */
  disabled: require('prop-types').bool,

  /**
   * Callback function that is fired when a radio button has been checked.
   */
  onChange: require('prop-types').func,

  /**
   * The content of Radio Button
   */
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node),

  /**
   * @ignore
   */
  groupValue: require('prop-types').string
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RadioButtonProps', {
  value: babelPluginFlowReactPropTypes_proptype_RadioButtonProps,
  configurable: true
});

var RadioButton = function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === undefined ? false : _this$props$disabled;

      if (disabled) return;
      onChange && onChange(event, _this.props.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioButton, [{
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props = this.props,
          name = _props.name,
          children = _props.children,
          value = _props.value,
          groupValue = _props.groupValue,
          onChange = _props.onChange,
          style = _props.style,
          className = _props.className,
          disabled = _props.disabled,
          otherProps = _objectWithoutProperties(_props, ['name', 'children', 'value', 'groupValue', 'onChange', 'style', 'className', 'disabled']);

      var checked = value !== undefined && value === groupValue;
      var classes = (0, _classnames2.default)(className, 'a-btn-group-item', (_ClassNames = {}, _defineProperty(_ClassNames, 'a-radio-btn-checked', !disabled && checked), _defineProperty(_ClassNames, 'disabled', disabled), _ClassNames));
      return _react2.default.createElement(
        'label',
        Object.assign({ className: classes, style: style }, otherProps),
        _react2.default.createElement('input', {
          className: 'a-btn-radio',
          type: 'radio',
          name: name,
          checked: !!checked,
          value: value,
          onChange: this.onChange.bind(this)
        }),
        _react2.default.createElement(
          'span',
          { className: 'a-btn-group-content' },
          children
        )
      );
    }
  }]);

  return RadioButton;
}(_react2.default.Component);

RadioButton.contextTypes = {
  radioGroup: _propTypes2.default.any
};


RadioButton.propTypes = {
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  groupValue: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

exports.default = RadioButton;